<glxy-confirmation-body>
  <mat-icon glxyConfirmationIcon class="icon" inline="true" color="primary">info</mat-icon>
  <glxy-confirmation-title>
    {{ 'LIB_ORDERS.SALES_ORDERS.ACTIVATION_DATE_CONFIRMATION_DIALOG.TITLE' | translate }}
  </glxy-confirmation-title>

  <glxy-confirmation-message>
    <p
      [innerHTML]="
        'LIB_ORDERS.SALES_ORDERS.ACTIVATION_DATE_CONFIRMATION_DIALOG.MESSAGE'
          | translate: { today: todayDate, date: orderDate }
      "
    ></p>
    <p>{{ 'LIB_ORDERS.SALES_ORDERS.ACTIVATION_DATE_CONFIRMATION_DIALOG.MESSAGE_2' | translate }}</p>
  </glxy-confirmation-message>
</glxy-confirmation-body>

<glxy-confirmation-actions>
  <glxy-confirmation-secondary-actions>
    <button mat-stroked-button mat-dialog-close>
      {{ 'LIB_ORDERS.COMMON.ORDERS.CANCEL' | translate }}
    </button>
  </glxy-confirmation-secondary-actions>
  <glxy-confirmation-primary-actions>
    <button mat-stroked-button (click)="proceedWithPreviousDate()">
      {{ 'LIB_ORDERS.SALES_ORDERS.ACTIVATION_DATE_CONFIRMATION_DIALOG.KEEP_ORIGINAL_DATE' | translate }}
    </button>
    <button mat-flat-button color="primary" [disabled]="updatingDate" (click)="proceedWithNewDate()">
      <glxy-button-loading-indicator [isLoading]="updatingDate">
        {{ 'LIB_ORDERS.SALES_ORDERS.ACTIVATION_DATE_CONFIRMATION_DIALOG.USE_TODAY' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </glxy-confirmation-primary-actions>
</glxy-confirmation-actions>
